import ReqError from "@source/api/reqError";
import { api } from "../http";
import {IGetHomesStatisticsReq} from "@source/api/models/statisticsModels";

export default class StatisticService {
  static async getUpdatesStatistic(data: { nursingHomes: string[], startDate: string, endDate: string; totals: boolean}) {
    try {
      return (await api.get(`statistic/home/download/updates-report?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, {
        responseType: 'arraybuffer',
        params: {
          nursingHomeIds: data.nursingHomes
        }
      })).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getUpdatesStatistic(e.response)
    }
  }

  static async getNursingHomeActualStatistic(nursingHomeId: string) {
    try {
      return (await api.get(`statistic/home/${nursingHomeId}/download/actual`, {responseType: 'arraybuffer'})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getNursingHomeActualStatisticError(e.response)
    }
  }

  static async getFamilyMembersActivationStatistic(nursingHomeId: string) {
    try {
      return (await api.get(`statistic/home/${nursingHomeId}/family-members-activation`, {responseType: 'arraybuffer'})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getEntryStatistic(entryId: string) {
    try {
      return (await api.get(`statistic/home/${entryId}/download/entry`, {responseType: 'arraybuffer'})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getEntryStatisticError(e.response)
    }
  }

  static async getEmployeeActivationStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    try {
      return (await api.get(`statistic/home/download/employee-activation?totals=${data.totals}`, {responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getEmployeeTrainingProgressStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    try {
      return (await api.get(`statistic/home/download/employee/training-progress?totals=${data.totals}`, {responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getResidentsStatistic(data:{ nursingHomes: string[]; totals: boolean}) {
    try {
      return (await api.get(`statistic/home/download/residents-report?totals=${data.totals}`, {
        responseType: 'arraybuffer',
        params: {
          nursingHomeIds: data.nursingHomes
        }
      })).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getNumbersStatistic(req: any) {
    try {
      return (await api.get(`statistic/homes/numbers?endDate=${req.endDate || ""}&startDate=${req.startDate || ""}&residentNumbers=${req.residentNumbers}`, {
        params: {
          nursingHomeIds: req.nursingHomes
        }
      })).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

    static async getEmployeeCreationByMonth(data: {
      nursingHomes: string[];
      startDate: string;
      endDate: string;
      totals: boolean
    }) {
      try {
        return (await api.get(`statistic/home/download/employee/update-creation-by-month?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
            nursingHomeIds: data.nursingHomes
          }})).data
      } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
        throw ReqError.getFamilyMembersActivationStatisticError(e.response)
      }
    }

  static async getAnnouncementCreationByMonth(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/employee/announcement-creation-by-month?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async downloadUnreadUpdateHistory(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/unread-updates-report?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.downloadResidentUpdateHistoryError(e)
    }
  }

  static async getAnnouncementTotalNumbers(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/employee/announcement-total-numbers?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getUpdateCreationByPosition(data: {
        nursingHomes: string[];
        startDate: string;
        endDate: string;
        totals: boolean
    }) {
      try {
        return (await api.get(`statistic/home/download/employee/update-creation-by-position?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
      } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
        throw ReqError.getFamilyMembersActivationStatisticError(e.response)
      }
    }

  static async getUpdateCreationByCategory(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/employee/update-creation-by-category?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getTopByUpdateCreation(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/employee/top-by-update-creation?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async downloadUpdateReadTimings(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/updates/update-read-timings?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async downloadUpdateCreateTimings(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/updates/update-create-timings?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }


  static async downloadUpdateReadTimingsAfterCreation(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/updates/update-read-timings-after-creation?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async downloadUpdateReadMoreThanOnce(data: {
    nursingHomes: string[];
    startDate: string;
    endDate: string;
    totals: boolean
  }) {
    try {
      return (await api.get(`statistic/home/download/updates/update-read-more-than-once?endDate=${data.endDate || ""}&startDate=${data.startDate || ""}&totals=${data.totals}`, { responseType: 'arraybuffer', params: {
          nursingHomeIds: data.nursingHomes
        }})).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getFamilyMembersActivationStatisticError(e.response)
    }
  }

  static async getSuperAdminStats(data: IGetHomesStatisticsReq) {
    try {
      return (await api.get(`admin/statistics/homes`, {
        params: data,
      })).data
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.getUpdatesStatistic(e.response)
    }
  }
}
